import MonitoringQueueEntriesTable from './MonitoringQueueEntriesTable';

export default MonitoringQueueEntriesTable;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/index.js